<template>
  <div class="header">
    <v-parallax
      dark
      :height="imageHeight"
      :src="bannerSrc"
    >
      <v-layout
        align-center
        column
        justify-center
      >
        <h1
          ref="title"
          class="header__title display-2 white--text"
        >
          <span class="font-weight-light">Just Another Movie App</span>
        </h1>
        <!-- <h4
          ref="subtitle"
          class="header__subtitle subheading font-weight-thin mt-2"
        >Ja... is woas! Wos für a einfallsreicher Name für a App in der ma Filme suacha kann! :-)</h4>-->
      </v-layout>
      <div class="header__overlay" />
    </v-parallax>
  </div>
</template>


<script>
const bannerSrc = require('../assets/banner.jpg');

export default {
  data() {
    return {
      animated: false,
      bannerSrc,
    };
  },

  computed: {
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '200';
        case 'sm':
          return '250';
        case 'md':
          return '300';
        case 'lg':
          return '300';
        case 'xl':
          return '350';
        default:
          return '300';
      }
    },
  },
  activated() {
    if (!this.animated) {
      this.$refs.title.classList.add('animate');
      // this.$refs.subtitle.classList.add("animated");
      this.animated = true;
    }
  },
  deactivated() {
    this.$refs.title.classList.remove('animate');
    // this.$refs.subtitle.classList.remove("animated");
  },
};
</script>

<style lang="scss">
.header {
  position: relative;

  &__img {
    display: block;
    width: 100% !important;
  }

  &__overlay {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(
      ellipse at center,
      rgba(0, 0, 0, 0.6) 0%,
      rgba(0, 0, 0, 0) 50%
    );
    z-index: 1;
  }

  &__title,
  &__subtitle {
    position: relative;
    z-index: 2;
  }

  &__subtitle.animate {
    animation-name: moveIn;
    animation-duration: 1s;
    animation-delay: 1s;
    animation-timing-function: ease-out;
  }

  &__title.animate {
    animation-name: fadeIn;
    animation-duration: 1.5s;
    animation-delay: 1s;
    animation-fill-mode: backwards;
    animation-timing-function: ease-out;
  }
}

@keyframes moveIn {
  0% {
    opacity: 0;
    transform: translateY(-100px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
